import { Component } from "react"
import { Container, Card, CardBody, CardTitle } from "reactstrap"
import { Link } from "react-router-dom"
import { Icon } from "@iconify/react"
import { video } from "../../redux/actions"
import url from "url"
import qs from "querystring"
import { connect } from "react-redux"

class SpecialGuest extends Component {
	getSpecialGuest() {
		this.props.getSpecialGuest()
	}

	componentDidMount() {
		this.getSpecialGuest()
	}

	render() {
		return (
			<Container>
				<Card className='card-stats mb-4 mb-xl-0'>
					<CardBody>
						<CardTitle g='h5' className='text-uppercase text-muted mb-0'>
							Special Guest
						</CardTitle>
						<div className='d-flex justify-content-center'>
							<Link to='/admin/video-resource'>
								<div
									className='img-content-slider'
									style={{
										backgroundImage: `url("${
											"https://img.youtube.com/vi/" +
											qs.parse(
												url.parse(this.props.specialGuest.youtube_url || "")
													.query
											)["v"] +
											"/default.jpg"
										}")`,
									}}
								>
									<div className='edit-fill'>
										<Icon icon='eva:edit-fill' />
									</div>
								</div>
							</Link>
						</div>
					</CardBody>
				</Card>
			</Container>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		specialGuest: state.video.specialGuest,
	}
}

const mapDispatchToProps = {
	getSpecialGuest: video.getSpecialGuest,
}

export default connect(mapStateToProps, mapDispatchToProps)(SpecialGuest)
